export type PasswordStrength = 'weak' | 'medium' | 'strong';

export const MIN_PASSWORD_LENGTH = 5;